import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import ScreenshotsFilter from "../modals/ScreenshotsFilter";
import ScreenshotDetectedText from "../modals/ScreenshotDetectedText";
import DeleteSelectedScreenshot from "../modals/DeleteSelectedScreenshot";
import ViewPicture from "../modals/ViewPicture";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import Select from "react-select";
import {
  calculateEndDate,
  formattedDateTime,
  handleDownloadClick,
  handleStartDate,
  handleStartDateCommon,
} from "../../../../utils/helper";
import moment from "moment";
import { isEmpty } from "lodash";
// import Swal from "sweetalert2";
// import { deleteScreenshot } from "../../AxiosRtk/Screenshot";
import { deleteNudity, getNudityData } from "../../AxiosRtk/Nudity";
import Download from "../modals/Download";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import useDurationOption from "../../../customHooks/durationOption";
import DateFilter from "../../../shared/DateFilter/DateFilter";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const Nudity = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [showModal, setShowModal] = useState(false);
  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const [selectedItem, setSelectedItem] = useState({});
  const { durationOptionsFunction } = useDurationOption();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const [selectedScreenshots, setSelectedScreenshots] = useState([]);
  const [screenshotListData, setScreenshotListData] = useState([]);
  const [detectedTextModal, setDetectedTextModal] = useState(false);
  const [selectToBeDeleted, setSelectToBeDeleted] = useState(0);
  const [downloadModal, setDownloadModal] = useState(false);
  const [filterData, setFilterData] = useState({
    selectedPackages: [],
    selectedCategoryIds: [],
    selectedKeyWords: [],
  });
  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const [deletedSelectedModal, setDeletedSelectedModal] = useState(false);
  const [kidData, setKidData] = useState(false);
  const [viewPictureModal, setViewPictureModal] = useState(false);
  const [detectedTextItem, setDetectedTextItem] = useState(null);
  const { getImage } = useKidListFunctionality();
  const { kidDevicesList, kidList, selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { ID: parentID } = useSelector(({ auth }) => auth.user);
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [deviceOptions, setDeviceOptions] = useState([]);
  useEffect(() => {
    setKidData(kidList?.find((item, index) => item.ID == selectedKidId));
    window.scrollTo(0, 0);
  }, []);

  const { getLangTranslation } = useLangTranslation();

  const handleGoBack = () => {
    history.goBack();
  };
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const openDetectedTextModal = (item) => {
    setDetectedTextItem(item);
    setDetectedTextModal(true);
  };
  const closeDetectedTextModal = () => {
    setDetectedTextModal(false);
  };
  const openDeletedSelected = () => {
    setDeletedSelectedModal(true);
  };
  const closeDeletedSelected = () => {
    setDeletedSelectedModal(false);
  };
  const openViewPicture = (item) => {
    setSelectedItem(item);
    setViewPictureModal(true);
  };
  const closeViewPicture = () => {
    setViewPictureModal(false);
  };
  const openDownloadPicture = () => {
    setDownloadModal(true);
  };
  const closeDownloadPicture = () => {
    setDownloadModal(false);
  };

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  const handleSelectAllChange = () => {
    if (selectedScreenshots.length === screenshotListData.length) {
      setSelectedScreenshots([]);
    } else {
      setSelectedScreenshots(screenshotListData.map((item) => item.nudityId));
    }
  };

  const handleSelectToBeDeletedCheckbox = () => {
    setSelectToBeDeleted((prevValue) => (prevValue === 0 ? 1 : 0));
  };

  const handleCheckboxChange = (nudityId) => {
    if (selectedScreenshots.includes(nudityId)) {
      setSelectedScreenshots(
        selectedScreenshots.filter((id) => id !== nudityId)
      );
    } else {
      setSelectedScreenshots([...selectedScreenshots, nudityId]);
    }
  };

  function getNudityScreenShotData() {
    if (selectedDeviceData && startDate) {
      const filterDate = moment(startDate)
        .locale("en")
        .format("YYYY-MM-DD HH:mm:ss");
      const obj = {
        kidId: selectedKidId,
        deviceId: selectedDeviceData?.ID,
        activityType: "NUDITY_ALERTS",
        startDate: startDate,
        endDate: endDate,
        pageNo: 1,
        itemsPerPage: 20000,
        nudityAppName: filterData
          ? filterData?.selectedPackages.toString()
          : "",
        nudityCategoryName: "",
        isDeletedImages: selectToBeDeleted,
      };
      getNudityData(obj)
        .then((res) => {
          setScreenshotListData(res?.data?.result);
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    }
  }

  useEffect(() => {
    getNudityScreenShotData();
  }, [
    startDate,
    endDate,
    selectedDeviceData?.ID,
    selectToBeDeleted,
    filterData.selectedKeyWords,
    filterData.selectedPackages,
  ]);

  // useEffect(() => {
  //   console.log(selectedScreenshots);
  // }, [selectedScreenshots]);
  const handleDelete = async (type) => {
    if (!isEmpty(selectedScreenshots)) {
      const payload = {
        nudityActivityId: selectedScreenshots.toString(),
        deviceId: selectedDeviceData?.ID,
        isDeleteAll: 0,
        activityType: "NUDITY_ALERTS",
        type: type,
      };
      try {
        const { data } = await deleteNudity(payload);
        if (data) {
          setTimeout(() => {
            dispatch(
              setShowMessage({
                showMessage: true,
                defaultMessage: data?.message,
                message: data?.message,
              })
            );
          }, 800);
          closeDeletedSelected();
          setSelectedScreenshots([]);
          getNudityScreenShotData();
        }
      } catch (error) {
        closeDeletedSelected();
        console.log(error);
      }
    }
  };

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  // useEffect(() => {
  //   console.log(deletedSelectedModal);
  // }, [deletedSelectedModal]);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  function getScreenshot(imgUrl) {
    if (imgUrl?.includes("https:")) {
      return imgUrl;
    }

    return `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW}/${btoa(
      parentID
    )}/Nudity/thumbnail/${imgUrl}`;
  }

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <Link
                    to="/"
                    className="text-blue-900 fs-5"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${
                        lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                      }`}
                    />
                  </Link>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "NUDITY_AND_IMAGE_CATEGORIZATION_TITLE",
                      "Nudity & image categorization"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img
                  src={getImage(
                    kidData?.image,
                    kidData?.gender,
                    kidData?.thumbnail
                  )}
                  alt=""
                  className="img-fluid"
                  onError={(event) => {
                    event.target.onerror = null;
                    event.target.src = getImage("", kidData?.gender);
                  }}
                />
              </span>
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon-nudity">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "NUDITY_AND_IMAGE_CATEGORIZATION_SELECT_DEVICE",
                    "Select Device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
            <div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  name="allSelect"
                  id="selectAll"
                  checked={
                    selectedScreenshots.length > 0 &&
                    selectedScreenshots.length === screenshotListData.length
                  }
                  onChange={handleSelectAllChange}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="selectAll"
                >
                  {getLangTranslation(
                    "NUDITY_AND_IMAGE_CATEGORIZATION_SELECT_ALL",
                    "Select All"
                  )}
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  name="allSelect"
                  id="deletedSoon"
                  checked={selectToBeDeleted === 1}
                  onChange={handleSelectToBeDeletedCheckbox}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="deletedSoon"
                >
                  {getLangTranslation(
                    "NUDITY_AND_IMAGE_CATEGORIZATION_SELECT_TO_BE_DELETED_SOON",
                    "Select to be deleted soon"
                  )}
                </label>
              </div>
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={openDeletedSelected}
              >
                {getLangTranslation(
                  "NUDITY_AND_IMAGE_CATEGORIZATION_BUTTON_DELETED_SELECTED",
                  "DELETE SELECTED"
                )}
              </button>
            </div>
            <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
              <DateFilter
                startDate={startDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                selectedDuration={selectedDuration}
              />
              <Select
                className="custom-select col-lg-4"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  handleStartDateCommon(
                    val,
                    setStartDate,
                    setSelectedDuration,
                    setEndDate
                  );
                }}
                options={durationOptions}
                value={
                  durationOptions?.find(
                    (item) => item?.value == selectedDuration
                  ) || ""
                }
              />
              <span className="icon-wrap pt-cursor" onClick={openModal}>
                <i className="icon-filter" />
              </span>
            </div>
          </div>
          <div className="grid gap-6">
            {screenshotListData?.map((item) => (
              <div className="g-col-12 g-col-md-6 g-col-lg-4">
                <div className=" ratio ratio-5x3 mb-3">
                  <img
                    className="rounded-3 cursor-pointer"
                    src={getScreenshot(item?.thumbnailPath)}
                    alt="nudity pic"
                    onClick={() => {
                      openViewPicture({
                        thumbnail: item?.thumbnailPath,
                        video: item?.nudityUrl,
                      });
                    }}
                  />
                  <input
                    className="form-check-input top-0 start-100 mt-3"
                    style={{ marginLeft: "-2rem" }}
                    type="checkbox"
                    value=""
                    checked={selectedScreenshots?.includes(item?.nudityId)}
                    onChange={() => handleCheckboxChange(item?.nudityId)}
                  />{" "}
                </div>
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div className="icon-wrap m-social">
                    <img src={item?.appIcon} alt="" width="30" />
                  </div>
                  <div className="d-flex flex-column">
                    <h5 className="text-small text-blue-900 mb-1">
                      {item?.appName}
                    </h5>
                    <span className="text-gray text-small">
                      {formattedDateTime(item?.nudityDateTime)}
                    </span>
                  </div>
                  <div
                    className="icon-wrap icon-blue ms-auto pt-cursor"
                    onClick={() =>
                      handleDownloadClick(getScreenshot(item?.nudityUrl))
                        .then((res) => {
                          openDownloadPicture();
                        })
                        .catch((error) => {
                          console.error("Download failed:", error);
                        })
                    }
                  >
                    <i className="icon-download fs-5" />
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between gap-3">
                  {item?.alertText !== "Safe" ? (
                    <div className="badge-pill danger">{item?.alertText}</div>
                  ) : (
                    <div></div>
                  )}
                  <span
                    className="text-blue-400 pt-cursor text-decoration-underline text-break"
                    onClick={() => openDetectedTextModal(item)}
                  >
                    {getLangTranslation(
                      "SCREENSHOT_DETECTED_TEXT",
                      "Detected text"
                    )}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ScreenshotsFilter
        showModal={showModal}
        closeModal={closeModal}
        filterData={filterData}
        setFilterData={setFilterData}
        getLangTranslation={getLangTranslation}
      />
      <ScreenshotDetectedText
        showModal={detectedTextModal}
        closeModal={closeDetectedTextModal}
        getLangTranslation={getLangTranslation}
        getScreenshot={getScreenshot}
        detectedTextData={detectedTextItem}
        type="NUDITY"
      />
      <DeleteSelectedScreenshot
        selectedDeviceId={selectedDeviceData?.ID}
        selectedScreenshots={selectedScreenshots}
        showModal={deletedSelectedModal}
        closeModal={closeDeletedSelected}
        handleDelete={handleDelete}
        getLangTranslation={getLangTranslation}
      />
      <ViewPicture
        showModal={viewPictureModal}
        closeModal={closeViewPicture}
        selectedItem={selectedItem}
        getLangTranslation={getLangTranslation}
      />
      <Download
        showModal={downloadModal}
        closeModal={closeDownloadPicture}
        getLangTranslation={getLangTranslation}
      />
    </>
  );
};

export default Nudity;
